import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CfetBaseComponent } from '../../cfet-core/components/cfet-base.component';

@Component({
    selector: 'app-bad-code-modal',
    templateUrl: './bad-code-modal.component.html',
    styleUrls: ['./bad-code-modal.component.scss'],
    standalone: false
})
export class BadCodeModalComponent extends CfetBaseComponent {

  constructor() { super(); }

  @Input() openModal: string;
  @Output() modalCloseEvent = new EventEmitter<any>();


  close(event: any, modalAction: string) {
    if (event.key === 'Enter' || event.type === 'click' || event.type === 'clicked outside' || event.keyCode === 13) {
      this[modalAction] = 'close';
      this.modalCloseEvent.emit('modalClose');
    }
  }
}
